import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography } from '@mui/material_modern'
import { DISPATCH_TICKET_STATUSES } from 'utils/constants'
import rem from 'utils/rem'
import { useSelector } from 'react-redux'

const DispatchActiveTicketsSummary = ({ dispatchTickets, requestedDispatchTickets }) => {
  const { unassignedTickets, completeTickets, inProgressTickets, failedTickets } = useMemo(
    () => ({
      unassignedTickets:
        dispatchTickets?.filter(ticket => ticket.status === DISPATCH_TICKET_STATUSES.UNASSIGNED.id) || [],
      completeTickets: dispatchTickets?.filter(ticket => ticket.status === DISPATCH_TICKET_STATUSES.COMPLETED.id) || [],
      inProgressTickets:
        dispatchTickets?.filter(ticket => ticket.status === DISPATCH_TICKET_STATUSES.IN_PROGRESS.id) || [],
      failedTickets: dispatchTickets?.filter(ticket => ticket.status === DISPATCH_TICKET_STATUSES.FAILED.id) || [],
    }),
    [dispatchTickets, requestedDispatchTickets],
  )

  return (
    <Stack
      sx={{
        backgroundColor: 'rgba(33, 150, 243, 0.1)',
        alignItems: 'center',
        padding: 1,
        paddingX: 4,
        borderRadius: 2,
      }}
      direction="row"
      spacing={2}
    >
      <Stack flex={1} alignItems="center">
        <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12), whiteSpace: 'nowrap' }} gutterBottom>
          TOTAL TICKETS
        </Typography>
        <Typography align="center">{dispatchTickets.length}</Typography>
      </Stack>
      <Stack>
        <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12), whiteSpace: 'nowrap' }} gutterBottom>
          REQUESTED
        </Typography>
        <Typography align="center">{requestedDispatchTickets.length}</Typography>
      </Stack>
      <Stack flex={1} alignItems="center">
        <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12), whiteSpace: 'nowrap' }} gutterBottom>
          UNASSIGNED
        </Typography>
        <Typography align="center">{unassignedTickets.length}</Typography>
      </Stack>
      <Stack flex={1} alignItems="center">
        <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12), whiteSpace: 'nowrap' }} gutterBottom>
          IN-PROGRESS
        </Typography>
        <Typography align="center">{inProgressTickets.length}</Typography>
      </Stack>
      <Stack flex={1} alignItems="center">
        <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12), whiteSpace: 'nowrap' }} gutterBottom>
          FAILED
        </Typography>
        <Typography align="center">{failedTickets.length}</Typography>
      </Stack>
      <Stack flex={1} alignItems="center">
        <Typography color="textSecondary" align="center" sx={{ fontSize: rem(12), whiteSpace: 'nowrap' }} gutterBottom>
          COMPLETE
        </Typography>
        <Typography align="center">{completeTickets.length}</Typography>
      </Stack>
    </Stack>
  )
}

DispatchActiveTicketsSummary.propTypes = {
  dispatchTickets: PropTypes.array.isRequired,
  requestedDispatchTickets: PropTypes.array,
}

DispatchActiveTicketsSummary.defaultProps = {
  requestedDispatchTickets: [],
}

export default DispatchActiveTicketsSummary
